import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export default class CheckPassValidation {
  static match(controlName: string, checkControlName: string): ValidatorFn {
    return (controls: AbstractControl) => {
      const control = controls.get(controlName);
      const checkControl = controls.get(checkControlName);

      if (checkControl?.errors && !checkControl.errors.matching) {
        return null;
      }

      if (control?.value !== checkControl?.value) {
        controls.get(checkControlName)?.setErrors({ matching: true });
        return { matching: true };
      } else {
        return null;
      }
    };
  }
}

export function atLeastOne(...fields: string[]) {
  return (controls: AbstractControl): ValidationErrors | null => {
    return fields.some((fieldName) => {
      const field = controls.get(fieldName)!.value;
      if (typeof field === 'boolean') return field ? true : false;
    })
      ? null
      : ({ atLeastOne: 'validation_project_type_required' } as ValidationErrors);
  };
}

export function validateProjectType(allowed: string[], errorMessage: string) {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value != null &&
      control.value.some((val: any) => {
        return allowed.some((a) => a === val.code);
      })
      ? null
      : ({ validateProjectType: errorMessage } as ValidationErrors);
  };
}

export function validateProjectTypeRequired(errorMessage: string) {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value != null && control.value.length > 0 ? null : ({ validateProjectType: errorMessage } as ValidationErrors);
  };
}

export function requiredIf(requiredInput: string, requiredIfInput: string) {
  return (controls: AbstractControl): ValidationErrors | null => {
    const control = controls.get(requiredInput);
    const checkControl = controls.get(requiredIfInput);

    if (control && checkControl) {
      return !control.value ? null : checkControl.value ? null : ({ required: 'Le champ ' + requiredIfInput + ' est [requis]' } as ValidationErrors);
    }
    return null;
  };
}

export function requiredIfNoValueToOtherInput(inputWithNoValue: string, requiredIfInput: string) {
  return (controls: AbstractControl): ValidationErrors | null => {
    const control = controls.get(inputWithNoValue);
    const checkControl = controls.get(requiredIfInput);

    if (control && checkControl) {
      return control.value ? null : checkControl.value ? null : ({ required: 'Le champ ' + requiredIfInput + ' est [requis]' } as ValidationErrors);
    }
    return null;
  };
}

export function requiredIfCondition(requiredCondition: boolean, requiredIfInput: AbstractControl, controlName: string) {
  if (requiredCondition && requiredIfInput) {
    return requiredIfInput.value || requiredIfInput.value == 0 ? null : ({ required: 'Le champ ' + controlName + ' est [requis]' } as ValidationErrors);
  }

  return null;
}

export function positiveIfCondition(condition: boolean, control: AbstractControl) {
  if (condition && control && control.value !== null && control.value !== '' && control.value <= 0) {
    return { positive: true } as ValidationErrors;
  }

  return null;
}
